/**
 * =====================================================
 * CART REDIRECT v10 — streetcup.store → streeetcup.store
 * ✅ Rápido e estável
 * ✅ Produtos normais + Kachhin sem SKU
 * ✅ Shopify Markets
 * ℹ️  Properties: o Kachhin da Loja 02 coleta no checkout
 * =====================================================
 */
(function () {

  const LOJA_02_URL = 'https://streeetcup.store';
  const resolvedIds = {};

  function getMarketContext() {
    const s = window.Shopify || {};
    return {
      currency:    s.currency?.active || s.currencyCode || null,
      countryCode: s.country || s.market?.countryCode || null
    };
  }

  async function resolveVariantIds(cartItems) {
    const handles = [...new Set(cartItems.map(i => i.handle))];
    await Promise.all(handles.map(async (handle) => {
      if (cartItems.filter(i => i.handle === handle).every(i => getVariantId(i))) return;
      try {
        const res = await fetch(`${LOJA_02_URL}/products/${handle}.js`, {
          mode: 'cors', credentials: 'omit'
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const p = await res.json();
        p.variants.forEach(v => {
          if (v.sku) resolvedIds[v.sku] = v.id;
          resolvedIds[`${handle}__${String(v.option1 || '').toLowerCase()}`] = v.id;
          if (!v.option1 || v.option1 === 'Default Title') {
            resolvedIds[`${handle}__default`]       = v.id;
            resolvedIds[`${handle}__default title`] = v.id;
          }
        });
      } catch (e) {
        console.warn(`[redirect] ⚠️ ${handle}:`, e.message);
      }
    }));
  }

  function getVariantId(item) {
    const h = item.handle || '';
    const o = String(item.variant_title || 'default title').toLowerCase();
    return resolvedIds[item.sku || '']
        || resolvedIds[`${h}__${o}`]
        || resolvedIds[`${h}__default`]
        || resolvedIds[`${h}__default title`]
        || null;
  }

  function buildRedirectURL(cartItems) {
    if (!cartItems?.length) return null;

    const items = cartItems.map(item => {
      const id = getVariantId(item);
      if (!id) { console.error(`[redirect] ❌ ${item.title}`); return null; }
      return `${id}:${item.quantity}`;
    }).filter(Boolean);

    if (!items.length) return null;

    const { currency, countryCode } = getMarketContext();
    const params = new URLSearchParams();
    if (currency)     params.set('currency', currency);
    if (countryCode)  params.set('country',  countryCode);

    const qs = params.toString();
    return `${LOJA_02_URL}/cart/${items.join(',')}${qs ? '?' + qs : ''}`;
  }

  async function redirectToLoja02(event) {
    event.preventDefault();
    event.stopPropagation();

    const btn = event.currentTarget;
    const orig = btn.innerHTML;
    btn.innerHTML = '<span>Aguarde...</span>';
    btn.disabled = true;

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      if (!cart.items?.length) { window.location.href = '/cart'; return; }

      await resolveVariantIds(cart.items);
      const url = buildRedirectURL(cart.items);

      if (url) {
        console.log('[redirect] v10 →', url);
        window.location.href = url;
      } else {
        throw new Error('Variant IDs não resolvidos');
      }
    } catch (e) {
      console.error('[redirect]', e.message);
      btn.innerHTML = orig;
      btn.disabled = false;
      window.location.href = '/checkout';
    }
  }

  function attachRedirect() {
    document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], [data-checkout-button]'
    ).forEach(btn => {
      if (btn.dataset.redirectAttached) return;
      btn.dataset.redirectAttached = 'true';
      btn.addEventListener('click', redirectToLoja02);
    });
  }

  new MutationObserver(() => attachRedirect())
    .observe(document.body, { childList: true, subtree: true });

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', attachRedirect)
    : attachRedirect();

  document.addEventListener('minimog:cart-updated', () => setTimeout(attachRedirect, 100));

  console.log('[redirect] ✅ v10 — estável e rápido');

})();